import getFullName from "@/helpers/getFullName";
import { Maybe } from '@/generated/graphql';

export default (givenName?: Maybe<string> , familyName?: Maybe<string>): string => {
  if (!givenName && !familyName) {
    return "n/a";
  }
  const firstName = givenName ?? "";
  const lastName = familyName ?? "";
  return getFullName(firstName, lastName);
};
